export const automatedCtaConstants = {
  AUTOMATED_CTA_SUCCESS: 'AUTOMATED_CTA_SUCCESS',
  AUTOMATED_CTA_FAILURE: 'AUTOMATED_CTA_FAILURE',
  GET_ALL_SPECIALITIES_SUCCESS: 'GET_ALL_SPECIALITIES_SUCCESS',
  GET_ALL_SPECIALITIES_FAILURE: 'GET_ALL_SPECIALITIES_FAILURE',
  SETTINGS: 'SETTINGS',
  USER_ACTION_LIST: 'USER_ACTION_LIST'
};
